import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton } from '@mui/material';
import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import { Button } from '@mui/material';

const SuccessDialog = ({ open, article, email, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          textAlign: 'center',
          p: 3
        }
      }}
    >
      <DialogTitle>
        <CheckCircleOutline sx={{ color: 'green', fontSize: 50 }} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">We are now reviewing your {article ? ' manuscript' : ' application'} and we will get back to you 
          via {' '} {email} with an update.
        </Typography>
        {article && <Typography>You can as well track your submisson status from your dashboard.</Typography>}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button variant="contained" onClick={onClose} sx={{ mt: 1 }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
